<template>
  <div>
    <div v-if="isLoading || isProcessing">
      <CanPayLoader/>
    </div>
  <div class="gift-card-received">
    <!-- Main Content -->
    <div class="main-content">
      <!-- Gift Card Icon -->
      <div class="gift-card-icon">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="118" height="106" viewBox="0 0 118 106" fill="none">
<path d="M102.486 21.8392H94.0532C95.1168 19.724 95.7173 17.4062 95.7173 15.0706C95.7173 7.67008 90.3024 0.179688 79.9591 0.179688C69.3039 0.179688 62.8103 7.9953 59.1669 14.8511C55.5235 7.9953 49.0299 0.179688 38.3747 0.179688C28.0314 0.179688 22.6165 7.67008 22.6165 15.0706C22.6165 17.4062 23.217 19.724 24.2806 21.8392H15.8479C7.63573 21.8392 0.957031 28.5179 0.957031 36.7301V90.8788C0.957031 99.091 7.63573 105.77 15.8479 105.77H102.486C110.698 105.77 117.377 99.091 117.377 90.8788V36.7301C117.377 28.5179 110.698 21.8392 102.486 21.8392ZM79.9591 8.30199C85.5961 8.30199 87.595 11.948 87.595 15.0706C87.595 18.1931 85.5961 21.8392 79.9591 21.8392H64.8372C67.1213 16.3459 71.8412 8.30199 79.9591 8.30199ZM38.3746 8.30199C46.4407 8.30199 51.1757 16.344 53.4787 21.8392H38.3746C32.7376 21.8392 30.7388 18.1931 30.7388 15.0706C30.7388 11.948 32.7376 8.30199 38.3746 8.30199ZM109.254 90.8788C109.254 94.6121 106.219 97.6474 102.486 97.6474H15.8479C12.1146 97.6474 9.07934 94.6121 9.07934 90.8788V84.1102H109.254L109.254 90.8788ZM109.254 75.9879H9.07934V36.7301C9.07934 32.9968 12.1146 29.9615 15.8479 29.9615H51.0459L39.6755 45.122C38.3271 46.9173 38.6919 49.4635 40.4845 50.8092C42.2824 52.155 44.8312 51.7822 46.169 49.9975L59.1668 32.6689L72.1646 49.9975C72.9578 51.0604 74.1794 51.6209 75.4168 51.6209C76.2628 51.6209 77.1195 51.3565 77.8492 50.8092C79.6418 49.4634 80.0067 46.9173 78.6583 45.122L67.2878 29.9615H102.486C106.219 29.9615 109.254 32.9968 109.254 36.7301V75.9879Z" fill="white"/>
</svg>
        </div>
      </div>

      <!-- Title -->
      <h1 class="page-title">You've Received a Gift Card</h1>

      <!-- Loading State with Skeleton Loaders -->
      <div v-if="isLoading" class="gift-cards-slider-container">
        <div class="gift-cards-slider">
          <div class="gift-card-slide" v-for="i in 3" :key="`skeleton-${i}`">
            <skeleton-gift-card></skeleton-gift-card>
          </div>
        </div>
      </div>

      <!-- No Gift Cards State -->
      <div v-if="giftCards.length === 0 && !isLoading" class="no-cards-container">
        <p class="no-cards-message" v-if="errorMessage">{{ errorMessage }}</p>
        <p class="no-cards-message" v-else>
          You haven't received any gift cards yet.
        </p>
      </div>

      <!-- Gift Cards Slider Container -->
      <div v-else class="gift-cards-slider-container">
        <div class="gift-cards-slider" ref="slider">
          <div
            v-for="(card, index) in giftCards"
            :key="card.id"
            :style="giftCards.length=== 1 ? 'margin: 0px auto!important;' : ''"
            class="gift-card-slide"
          >
            <div class="gift-card-details">
              <!-- Amount Header Section -->
              <div class="amount-section">
                <div class="amount">${{ card.amount }}</div>
                <div class="date-time">
                  <div class="date">
                    Received on:
                  </div>
                  <div class="date">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 42 42" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.967 0C14.0992 0 15.017 0.940212 15.017 2.1H31.417C37.0779 2.1 41.667 6.80102 41.667 12.6V31.5C41.667 37.2989 37.0779 42 31.417 42H10.917C5.25608 42 0.666992 37.2989 0.666992 31.5V12.6C0.666992 6.80102 5.25608 2.1 10.917 2.1C10.917 0.940212 11.8348 0 12.967 0ZM10.917 6.3C7.52045 6.3 4.76699 9.12061 4.76699 12.6V31.5C4.76699 34.9795 7.52045 37.8 10.917 37.8H31.417C34.8136 37.8 37.567 34.9795 37.567 31.5V12.6C37.567 9.12061 34.8136 6.3 31.417 6.3H15.017V8.4C15.017 9.55979 14.0992 10.5 12.967 10.5C11.8348 10.5 10.917 9.55979 10.917 8.4V6.3Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.367 0C30.4992 0 31.417 0.940212 31.417 2.1V8.4C31.417 9.55979 30.4992 10.5 29.367 10.5C28.2348 10.5 27.317 9.55979 27.317 8.4V2.1C27.317 0.940212 28.2348 0 29.367 0Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.719 17.3681C29.5449 18.1612 29.5868 19.4901 28.8125 20.3362L21.125 28.7362C20.3907 29.5388 19.1762 29.6247 18.3411 28.9334L13.7285 25.1152C12.8479 24.3863 12.7109 23.0641 13.4225 22.1619C14.1341 21.2598 15.4248 21.1195 16.3054 21.8484L19.4366 24.4404L25.8213 17.4638C26.5958 16.6176 27.893 16.5748 28.719 17.3681Z" fill="black"/>
                    </svg>
                    {{ card.date }}
                  </div>
                  <div class="time">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 45 44" fill="none">
                    <path d="M22.667 0.171875C10.6271 0.171875 0.838867 9.96016 0.838867 22C0.838867 34.0398 10.6271 43.8281 22.667 43.8281C34.7068 43.8281 44.4951 34.0398 44.4951 22C44.4951 9.96016 34.7068 0.171875 22.667 0.171875ZM22.667 39.4625C13.042 39.4625 5.20449 31.625 5.20449 22C5.20449 12.375 13.042 4.5375 22.667 4.5375C32.292 4.5375 40.1295 12.375 40.1295 22C40.1295 31.625 32.292 39.4625 22.667 39.4625Z" fill="black"/>
                    <path d="M24.8498 20.8312V11.0859C24.8498 9.88281 23.8701 8.90312 22.667 8.90312C21.4639 8.90312 20.4842 9.88281 20.4842 11.0859V22C20.4842 22.7305 20.8451 23.4094 21.4553 23.8133L28.0037 28.1789C28.3732 28.4281 28.7943 28.5484 29.2154 28.5484C29.9201 28.5484 30.6162 28.2047 31.0373 27.5773C31.7076 26.5719 31.4326 25.2227 30.4357 24.5523L24.8498 20.8312Z" fill="black"/>
                    </svg>
                    {{ card.time }}
                  </div>
                </div>
              </div>

              <!-- Other Details with Padding -->
              <div class="details-content">
                <div class="card-content-sections">
                  <!-- Location -->
                  <div class="location-section" v-if="card.location">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 51 64" fill="none">
                    <path d="M25.6265 14.163C19.228 14.163 14.0224 19.3686 14.0224 25.7671C14.0224 32.1656 19.228 37.3712 25.6265 37.3712C32.0249 37.3712 37.2306 32.1656 37.2306 25.7671C37.2306 19.3686 32.0251 14.163 25.6265 14.163ZM25.6265 32.4853C21.9221 32.4853 18.9083 29.4715 18.9083 25.7671C18.9083 22.0627 21.9221 19.0489 25.6265 19.0489C29.3309 19.0489 32.3447 22.0627 32.3447 25.7671C32.3447 29.4715 29.3309 32.4853 25.6265 32.4853Z" fill="black"/>
                    <path d="M25.6265 0.726562C11.819 0.726562 0.585938 11.9598 0.585938 25.7671V26.4593C0.585938 33.4423 4.58944 41.5797 12.4856 50.645C18.2097 57.2168 23.8539 61.7993 24.0912 61.9912L25.6265 63.2317L27.1617 61.9913C27.3992 61.7994 33.0433 57.217 38.7673 50.6451C46.6634 41.5797 50.667 33.4424 50.667 26.4594V25.7672C50.667 11.9598 39.4339 0.726562 25.6265 0.726562ZM45.7811 26.4594C45.7811 38.2603 30.5759 52.5456 25.6265 56.8821C20.6757 52.5442 5.47184 38.2595 5.47184 26.4594V25.7672C5.47184 14.654 14.5132 5.61259 25.6265 5.61259C36.7397 5.61259 45.7811 14.654 45.7811 25.7672V26.4594Z" fill="black"/>
                    </svg>
                    <span class="location-text">{{ card.location }}</span>
                  </div>

                  <!-- From Section -->
                  <div class="from-section">
                    <div class="section-label">From:</div>
                    <div class="from-name note-section-name-fixed-height">{{ card.from_name }}</div>
                  </div>

                  <!-- Note Section -->
                  <div class="note-section " v-if="card.note">
                    <div class="section-label">Note:</div>
                    <div class="note-text note-section-fixed-height">{{ card.note }}</div>
                  </div>
                </div>

                <!-- Action Button -->
                <div class="action-button-container">
                  <button class="action-button" @click="handleAction(card, index)">
                    {{ getActionButtonText(card) }}
                  </button>
                  <!-- Send Thank You Button -->
                  <!-- <button
                    class="thank-you-button"
                    @click="handleSendThankYou(card, index)"
                    :disabled="card.thankYouSent"
                    :class="{ 'thank-you-sent': card.thankYouSent }"
                  >
                    {{ card.thankYouSent ? 'Thank You Sent' : 'Send Thank You' }}
                  </button> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Horizontal Loading State with Skeleton -->
          <div v-if="isLoadingMore" class="gift-card-slide">
            <skeleton-gift-card></skeleton-gift-card>
          </div>
        </div>
      </div>
    </div>

    <!-- Gift Card Added Modal -->
    <b-modal
      ref="gift-card-added-modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      modal-backdrop
      hide-header
      id="gift-card-added-modal"
      centered
    >
      <div class="gift-card-modal-content">
        <!-- Icon with checkmark -->
        <div class="modal-icon-container">
          <div class="modal-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 118 106" fill="none">
              <path d="M102.486 21.8392H94.0532C95.1168 19.724 95.7173 17.4062 95.7173 15.0706C95.7173 7.67008 90.3024 0.179688 79.9591 0.179688C69.3039 0.179688 62.8103 7.9953 59.1669 14.8511C55.5235 7.9953 49.0299 0.179688 38.3747 0.179688C28.0314 0.179688 22.6165 7.67008 22.6165 15.0706C22.6165 17.4062 23.217 19.724 24.2806 21.8392H15.8479C7.63573 21.8392 0.957031 28.5179 0.957031 36.7301V90.8788C0.957031 99.091 7.63573 105.77 15.8479 105.77H102.486C110.698 105.77 117.377 99.091 117.377 90.8788V36.7301C117.377 28.5179 110.698 21.8392 102.486 21.8392ZM79.9591 8.30199C85.5961 8.30199 87.595 11.948 87.595 15.0706C87.595 18.1931 85.5961 21.8392 79.9591 21.8392H64.8372C67.1213 16.3459 71.8412 8.30199 79.9591 8.30199ZM38.3746 8.30199C46.4407 8.30199 51.1757 16.344 53.4787 21.8392H38.3746C32.7376 21.8392 30.7388 18.1931 30.7388 15.0706C30.7388 11.948 32.7376 8.30199 38.3746 8.30199ZM109.254 90.8788C109.254 94.6121 106.219 97.6474 102.486 97.6474H15.8479C12.1146 97.6474 9.07934 94.6121 9.07934 90.8788V84.1102H109.254L109.254 90.8788ZM109.254 75.9879H9.07934V36.7301C9.07934 32.9968 12.1146 29.9615 15.8479 29.9615H51.0459L39.6755 45.122C38.3271 46.9173 38.6919 49.4635 40.4845 50.8092C42.2824 52.155 44.8312 51.7822 46.169 49.9975L59.1668 32.6689L72.1646 49.9975C72.9578 51.0604 74.1794 51.6209 75.4168 51.6209C76.2628 51.6209 77.1195 51.3565 77.8492 50.8092C79.6418 49.4634 80.0067 46.9173 78.6583 45.122L67.2878 29.9615H102.486C106.219 29.9615 109.254 32.9968 109.254 36.7301V75.9879Z" fill="#179346"/>
            </svg>
            <!-- Checkmark overlay -->
            <div class="checkmark-overlay">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill="#179346"/>
                <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- Modal Text -->
        <div class="modal-text-content">
          <h3 class="modal-title">Gift Card has been added<br/> to your account.</h3>
          <div class="modal-amount">${{ currentGiftCardAmount }}</div>
          <p class="modal-subtitle">Is available now in your<br/> CanPay Points.</p>
        </div>

        <!-- OK Button -->
        <button class="modal-ok-button" @click="closeModal">
          OK
        </button>
      </div>
    </b-modal>

    <!-- Message Modal -->
    <gift-card-message-modal ref="GiftCardMessageModal" :messageText="modalMessage"></gift-card-message-modal>
  </div>
  </div>
</template>

<script>
import api from "../../api/giftcard.js";
import moment from 'moment';
import CanPayLoader from "../CustomLoader/CanPayLoader.vue";
import GiftCardMessageModal from "./Modal/GiftCardMessageModal.vue";
import SkeletonGiftCard from "./SkeletonGiftCard.vue";
export default {
  name: 'GiftCardReceived',
  data() {
    return {
      componentId: Math.random().toString(36).substring(2, 11), // Unique component instance ID
      apiCallInProgress: false, // Guard to prevent duplicate API calls
      currentSlide: 0,
      giftCards: [],
      touchStartX: 0,
      touchEndX: 0,
      isSliding: false,
      currentGiftCardAmount: '0.00',
      mouseStartX: 0,
      mouseEndX: 0,
      isDragging: false,
      isLoading: false,
      errorMessage: '',
      currentPage: 1,
      perPage: 10,
      hasMorePages: true,
      isLoadingMore: false,
      modalMessage: '', // Message to show in modal
      isProcessing: false, // For button loading states
      preloadThreshold: 2, // Load next page when within 2 cards of the end
      cardIdToRemove: null, // Track which card is being removed to prevent index issues
      removingCardId: null // ID of card currently being removed
    }
  },
  watch:{
    giftCards(newValue) {
      // Redirect if no gift cards and loading is complete
      if (newValue.length === 0 && !this.isLoading && !this.isLoadingMore) {
        // Add a small delay to ensure the component is fully rendered
        setTimeout(() => {
          this.redirectFunction();
        }, 500);
      }
    }
  },
  components:{
    CanPayLoader,
    GiftCardMessageModal,
    SkeletonGiftCard
  },
  computed: {
    actionButtonText() {
      // This could be dynamic based on gift card status
      return 'Cool';
    }
  },

  methods: {
    redirectFunction(){
      this.$router.push('/my-gift-cards');
    },
    async fetchSharedGiftCards(page = 1, append = false) {
      console.log(`[${this.componentId}] fetchSharedGiftCards called with page:`, page, 'append:', append, 'at:', new Date().toISOString());

      // Guard against duplicate API calls
      if (this.apiCallInProgress && !append) {
        console.log(`[${this.componentId}] API call already in progress, skipping duplicate call`);
        return;
      }

      this.apiCallInProgress = true;

      if (append) {
        this.isLoadingMore = true;
      } else {
        this.isLoading = true;
        this.giftCards = []; // Reset gift cards for initial load
        this.currentPage = 1;
        this.hasMorePages = true;
      }
      this.errorMessage = '';

      try {
        const payload = {
          page: page,
          per_page: this.perPage
        };

        console.log(`[${this.componentId}] Making API call to getGiftCardDetailsShared with payload:`, payload);
        const response = await api.getGiftCardDetailsShared(payload);
        console.log('API Response:', response); // Debug log

        if (response.code === 200 && response.data) {
          // Transform the API response to match the component's expected format
          const newGiftCards = response.data.data.map(card => {
            console.log('Processing card:', card); // Debug log
            return {
              id: card.id || card.gift_card_id, // Include the ID for API calls - CRITICAL for removal
              amount: parseFloat(card.amount || 0).toFixed(2),
              date: this.formatDate(card.updated_at || card.created_at || card.date),
              time: this.formatTime(card.updated_at || card.created_at || card.time),
              location: card.location || null,
              from_name: card.from_name || card.from || 'Unknown',
              note: card.note || card.message || null,
              thankYouSent: false // Track thank you state
            };
          });

          if (append) {
            // Append new cards to existing ones - smooth append without jank
            this.giftCards = [...this.giftCards, ...newGiftCards];
          } else {
            // Replace cards for initial load
            this.giftCards = newGiftCards;
          }

          // Update pagination state
          this.currentPage = page;
          this.hasMorePages = newGiftCards.length === this.perPage;
          console.log('Has more pages:', this.hasMorePages); // Debug log
          console.log('Transformed gift cards:', this.giftCards); // Debug log
        } else {
          if (!append) {
            this.giftCards = [];
          }
          this.errorMessage = response.message || 'Failed to fetch shared gift cards';
          this.hasMorePages = false;
          console.log('API Error:', response); // Debug log
        }
      } catch (error) {
        console.error('Error fetching shared gift cards:', error);
        if (!append) {
          this.giftCards = [];
        }
        this.errorMessage = 'Failed to fetch shared gift cards. Please try again.';
        this.hasMorePages = false;
      } finally {
        this.isLoading = false;
        this.isLoadingMore = false;
        this.apiCallInProgress = false; // Reset the guard
        console.log(`[${this.componentId}] API call completed, guard reset`);
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatTime(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('hh:mm A');
    },

    async loadNextPage() {
      if (!this.hasMorePages || this.isLoadingMore) return;

      const nextPage = this.currentPage + 1;
      console.log('Loading next page:', nextPage); // Debug log

      await this.fetchSharedGiftCards(nextPage, true);
    },

    // Check if we need to preload the next page
    checkAndPreloadNextPage() {
      if (!this.hasMorePages || this.isLoadingMore || this.apiCallInProgress) return;

      // Calculate distance from end
      const distanceFromEnd = this.giftCards.length - this.currentSlide;

      // Preload when within threshold cards from the end
      if (distanceFromEnd <= this.preloadThreshold) {
        console.log('Preloading next page, distance from end:', distanceFromEnd);
        this.loadNextPage();
      }
    },

    async handleAction(card, index) {
      // Handle the main action (Cool button - update share status)
      console.log('Gift card Cool action clicked', card, index);
      console.log('Card ID for API call:', card.id);

      // Prevent duplicate processing of same card
      if (this.removingCardId === card.id) {
        console.log('Card already being processed, skipping duplicate action');
        return;
      }

      // Show loader
      this.isProcessing = true;
      this.removingCardId = card.id;

      try {
        const payload = {
          gift_card_id: card.id
        };

        console.log('Sending payload to updateGiftCardShareStatus:', payload);
        const response = await api.updateGiftCardShareStatus(payload);

        if (response.code === 200) {
          // Hide loader
          this.isProcessing = false;

          // Set the current gift card amount for the existing modal
          this.currentGiftCardAmount = card.amount;
          // Show the existing modal directly
          this.showModal();

          // Remove the card from the display after successful action
          setTimeout(() => {
            // Find and remove card by ID instead of index (safer approach)
            const cardIndex = this.giftCards.findIndex(c => c.id === card.id);
            if (cardIndex !== -1) {
              console.log('Removing card with ID:', card.id, 'at index:', cardIndex);
              this.giftCards.splice(cardIndex, 1);
              console.log('Card removed from display, remaining cards:', this.giftCards.length);

              // Adjust current slide if necessary
              if (this.giftCards.length === 0) {
                this.currentSlide = 0;
              } else if (this.currentSlide >= this.giftCards.length) {
                this.currentSlide = this.giftCards.length - 1;
              }

              // Update slider position with proper timing
              this.$nextTick(() => {
                setTimeout(() => {
                  this.updateSliderPosition();
                }, 50);
              });
            }
            this.removingCardId = null;
          }, 1000); // Delay to let user see both modals
        } else {
          console.error('Failed to update share status:', response.message);
          this.isProcessing = false;
          this.removingCardId = null;
          this.modalMessage = 'Failed to update status. Please try again.';
          this.$refs['GiftCardMessageModal'].showMessageModal();
        }
      } catch (error) {
        console.error('Error updating share status:', error);
        this.isProcessing = false;
        this.removingCardId = null;
        this.modalMessage = 'Failed to update status. Please try again.';
        this.$refs['GiftCardMessageModal'].showMessageModal();
      }
    },
    async handleSendThankYou(card, index) {
      // Handle sending thank you message
      console.log('Send thank you clicked', card, index);
      console.log('Card ID for thank you API call:', card.id);

      // Prevent duplicate processing of same card
      if (this.removingCardId === card.id) {
        console.log('Card already being processed, skipping duplicate action');
        return;
      }

      // Show loader
      this.isProcessing = true;
      this.removingCardId = card.id;

      try {
        const payload = {
          gift_card_id: card.id
        };

        console.log('Sending payload to sendAppreciation:', payload);
        const response = await api.sendAppreciation(payload);

        if (response.code === 200) {
          // Hide loader
          this.isProcessing = false;

          // Mark card as thank you sent
          const cardIndex = this.giftCards.findIndex(c => c.id === card.id);
          if (cardIndex !== -1) {
            this.giftCards[cardIndex].thankYouSent = true;
          }

          // Show "Successfully sent gratification" message in modal
          this.modalMessage = 'Successfully sent gratification';
          console.log('🔍 Trying to show modal with message:', this.modalMessage);
          console.log('🔍 Modal ref exists:', !!this.$refs['GiftCardMessageModal']);

          // Use $nextTick to ensure DOM is updated with new message
          this.$nextTick(() => {
            if (this.$refs['GiftCardMessageModal']) {
              console.log('🚀 Calling showMessageModal...');
              this.$refs['GiftCardMessageModal'].showMessageModal();

              // Fallback check after 500ms
              setTimeout(() => {
                const modalElement = document.getElementById('gift-card-message-modal');
                if (!modalElement || modalElement.style.display !== 'block') {
                  console.log('🔄 Custom modal failed, using fallback...');
                  this.showSimpleModal('Successfully sent gratification');
                }
              }, 500);
            } else {
              console.error('❌ Modal ref not found! Using fallback...');
              this.showSimpleModal('Successfully sent gratification');
            }
          });

          // Remove the card from the display after successful thank you
          setTimeout(() => {
            // Find and remove card by ID instead of index
            const removeIndex = this.giftCards.findIndex(c => c.id === card.id);
            if (removeIndex !== -1) {
              this.giftCards.splice(removeIndex, 1);

              // Adjust current slide if necessary
              if (this.giftCards.length === 0) {
                this.currentSlide = 0;
              } else if (this.currentSlide >= this.giftCards.length) {
                this.currentSlide = this.giftCards.length - 1;
              }

              // Update slider position with proper timing
              this.$nextTick(() => {
                setTimeout(() => {
                  this.updateSliderPosition();
                }, 50);
              });
            }
            this.removingCardId = null;
          }, 1500); // Small delay after modal
        } else {
          console.error('Failed to send thank you:', response.message);
          this.isProcessing = false;
          this.removingCardId = null;
          this.modalMessage = 'Failed to send thank you message. Please try again.';
          this.$refs['GiftCardMessageModal'].showMessageModal();
        }
      } catch (error) {
        console.error('Error sending thank you message:', error);
        this.isProcessing = false;
        this.removingCardId = null;
        this.modalMessage = 'Failed to send thank you message. Please try again.';
        this.$refs['GiftCardMessageModal'].showMessageModal();
      }
    },
    getActionButtonText() {
      // This could be dynamic based of gift card status
      // For now, return the same text for all cards
      return 'Cool';
    },



    // Fallback method using Bootstrap Vue's built-in modal
    showSimpleModal(message) {
      console.log('🔄 Using fallback modal approach:', message);
      if (this.$bvModal) {
        this.$bvModal.msgBoxOk(message, {
          title: 'Gift Card',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        });
      } else {
        console.error('❌ $bvModal not available, falling back to alert');
        alert(message);
      }
    },
    showModal() {
      this.$bvModal.show('gift-card-added-modal');
    },
    closeModal() {
      this.$bvModal.hide('gift-card-added-modal');
    },

    async nextSlide() {
      if (this.isSliding || this.isLoadingMore || this.giftCards.length === 0) return;

      this.isSliding = true;
      this.currentSlide = (this.currentSlide + 1) % this.giftCards.length;
      this.updateSliderPosition();

      // Check if we need to preload the next page (intelligent preloading)
      this.checkAndPreloadNextPage();
    },
    prevSlide() {
      if (this.isSliding || this.giftCards.length === 0) return;

      this.isSliding = true;
      this.currentSlide = this.currentSlide === 0 ? this.giftCards.length - 1 : this.currentSlide - 1;
      this.updateSliderPosition();
    },
    updateSliderPosition() {
      if (!this.$refs.slider || this.giftCards.length === 0) {
        this.isSliding = false;
        return;
      }

      this.isSliding = true;

      // Ensure currentSlide is within valid range
      if (this.currentSlide >= this.giftCards.length) {
        this.currentSlide = Math.max(0, this.giftCards.length - 1);
      }

      // Calculate the translation to show each card fully
      // Each slide moves by the card width + margin to show the full card
      const containerElement = this.$refs.slider.parentElement;
      if (!containerElement) {
        this.isSliding = false;
        return;
      }

      const containerWidth = containerElement.offsetWidth;
      // Mobile: 50px padding, 15px margin | Desktop: 60px padding, 20px margin
      const paddingRight = window.innerWidth <= 767 ? 50 : 60;
      const marginWidth = window.innerWidth <= 767 ? 15 : 20;
      const cardWidth = containerWidth - paddingRight;

      // Move by card width + margin for each slide to ensure full card visibility
      const slideDistance = (cardWidth + marginWidth) * this.currentSlide;
      const translateX = -slideDistance;

      // Use GPU acceleration for smooth animations
      this.$refs.slider.style.transform = `translateX(${translateX}px)`;
      this.$refs.slider.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
      this.$refs.slider.style.willChange = 'transform';

      // Reset sliding flag after animation completes
      setTimeout(() => {
        this.isSliding = false;
        if (this.$refs.slider) {
          this.$refs.slider.style.willChange = 'auto';
        }
      }, 350); // Slightly longer than transition time to ensure completion
    },
    handleTouchStart(e) {
      // Reset sliding flag to allow new swipes
      this.isSliding = false;
      this.touchStartX = e.touches[0].clientX;
    },
    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    },
    async handleTouchEnd() {
      if (!this.touchStartX || !this.touchEndX) return;

      const difference = this.touchStartX - this.touchEndX;
      const minSwipeDistance = 50;

      if (Math.abs(difference) > minSwipeDistance && !this.isSliding) {
        if (difference > 0) {
          // Swiped left - next slide
          await this.nextSlide();
        } else {
          // Swiped right - previous slide
          this.prevSlide();
        }
      }

      this.touchStartX = 0;
      this.touchEndX = 0;
    },
    handleResize() {
      // Recalculate slider position on window resize
      this.updateSliderPosition();
    },
    handleMouseDown(e) {
      // Reset sliding flag to allow new drags
      this.isSliding = false;
      this.mouseStartX = e.clientX;
      this.isDragging = true;
    },
    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.mouseEndX = e.clientX;
    },
    async handleMouseUp() {
      if (!this.isDragging) return;

      const difference = this.mouseStartX - this.mouseEndX;
      const minSwipeDistance = 50;

      if (Math.abs(difference) > minSwipeDistance && !this.isSliding) {
        if (difference > 0) {
          // Dragged left - next slide
          await this.nextSlide();
        } else {
          // Dragged right - previous slide
          this.prevSlide();
        }
      }

      this.mouseStartX = 0;
      this.mouseEndX = 0;
      this.isDragging = false;
    }
  },
  async mounted() {
    console.log(process.env.VUE_APP_GIFT_CARD_PURCHASE_DISABLED)
    console.log(`GiftCardReceived component [${this.componentId}] mounted at:`, new Date().toISOString());

    // Configure to show common header with left menu and logo
    this.$root.$emit("changeWhiteBackground", [false, true, 'common', false]);
    this.$root.$emit("show_header", true);

    // Hide the reward wheel icon for this page
    this.$root.$emit("showSpinInfo", {show_spin_info: false});

    // Fetch shared gift cards from API
    await this.fetchSharedGiftCards();

    // If gift card data is passed via route params or query (fallback)
    if (this.$route.params.giftCardData && this.giftCards.length === 0) {
      // If single gift card data is passed and no API data, use it as fallback
      this.giftCards = [this.$route.params.giftCardData];
    }

    // Add touch event listeners for mobile swipe
    const slider = this.$refs.slider;
    if (slider) {
      slider.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      slider.addEventListener('touchmove', this.handleTouchMove, { passive: true });
      slider.addEventListener('touchend', this.handleTouchEnd, { passive: true });

      // Add mouse event listeners for desktop drag
      slider.addEventListener('mousedown', this.handleMouseDown);
      slider.addEventListener('mousemove', this.handleMouseMove);
      slider.addEventListener('mouseup', this.handleMouseUp);
      slider.addEventListener('mouseleave', this.handleMouseUp); // Handle mouse leaving slider area
    }

    // Initialize slider position
    this.$nextTick(() => {
      this.updateSliderPosition();
    });

    // Add window resize listener to recalculate positions
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    console.log(`GiftCardReceived component [${this.componentId}] being destroyed at:`, new Date().toISOString());

    // Remove touch and mouse event listeners
    const slider = this.$refs.slider;
    if (slider) {
      slider.removeEventListener('touchstart', this.handleTouchStart);
      slider.removeEventListener('touchmove', this.handleTouchMove);
      slider.removeEventListener('touchend', this.handleTouchEnd);

      // Remove mouse event listeners
      slider.removeEventListener('mousedown', this.handleMouseDown);
      slider.removeEventListener('mousemove', this.handleMouseMove);
      slider.removeEventListener('mouseup', this.handleMouseUp);
      slider.removeEventListener('mouseleave', this.handleMouseUp);
    }

    // Remove window resize listener
    window.removeEventListener('resize', this.handleResize);

    // Restore reward wheel visibility when leaving this page
    this.$root.$emit("showSpinInfo", {show_spin_info: true});
    this.$root.$emit("show_header", true);
  }
}
</script>

<style scoped>
/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #179346;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

/* Error State */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.error-message {
  color: #dc3545;
  font-size: 16px;
  margin-bottom: 20px;
}

.retry-button {
  background-color: #179346;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.retry-button:hover {
  background-color: #0f6b32;
}

/* No Cards State */
.no-cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.no-cards-message {
  color: #FFFFFF;
  font-size: 16px;
  margin: 0;
}
.note-section-fixed-height{
    height: 140px;
    overflow-y: scroll;
    scrollbar-width: none;
    word-break: break-all;
}
.gift-card-font-weight-600{
  font-weight:600;
}
.note-section-name-fixed-height{
    word-break: break-all;
    height: 22px;
    overflow-y: scroll;
    scrollbar-width: none;
}

/* Horizontal Loading State */
.loading-slide {
  width: calc(100% - 60px);
  flex-shrink: 0;
  margin-right: 20px;
  display: flex;
  align-items: stretch;
}

.loading-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 395px;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
}

.horizontal-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.horizontal-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #179346;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.horizontal-loading-text {
  color: #666;
  font-size: 16px;
  margin: 0;
  font-family: 'Open Sans', sans-serif;
}

/* Mobile responsive adjustments for horizontal loading */
@media (max-width: 767px) {
  .loading-slide {
    width: calc(100% - 50px);
    margin-right: 15px;
  }

  .loading-card {
    min-height: 345px;
  }

  .horizontal-loading-container {
    padding: 30px 16px;
  }

  .horizontal-loading-spinner {
    width: 32px;
    height: 32px;
    border-width: 3px;
  }

  .horizontal-loading-text {
    font-size: 14px;
  }
}

/* Thank You Button Styles */
.thank-you-button {
  background-color: #179346;
  color: white;
  border: none;
  padding: 15px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px;
}

.thank-you-button:hover:not(:disabled) {
  background-color: #0f6b32;
  transform: translateY(-1px);
}

.thank-you-button:disabled,
.thank-you-button.thank-you-sent {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.7;
}

.thank-you-button.thank-you-sent {
  background-color: #28a745;
}

/* Action Button Container */
.action-button-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 15px;
}

.action-button {
  background-color: #000000;
  color: white;
  border: none;
  padding: 15px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}


/* Mobile responsive for buttons */
@media (max-width: 767px) {
  .action-button-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .thank-you-button {
    margin-left: 0;
    width: 100%;
  }

  .action-button {
    width: 100%;
  }
}
</style>
